module.exports = __webpack_public_path__ + "static/media/back-arrow-dark.c2b775ad.svg";